//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isWorker } from '@/api/mamixiaowu'
export default {
  components: {},
  data () {
    return {
      sourcetype: 1
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    auth () {
      return this.$store.state.user.workerObj.auth || ''
    }
  },
  mounted () {
    let workerObj = this.$store.state.user.workerObj
    if (Object.keys(workerObj).length === 0) {
      this.getIsWorker()
    }
  },
  methods: {
    // 判断是否为工作人员
    getIsWorker () {
      isWorker({
        accountid: this.accountid,
        sourcetype: this.sourcetype
      }).then(data => {
        this.$store.commit('setWorkerObj', data.returnValue)
      })
    }
  }
}
